
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.2902 8.70998L6.70021 13.3C6.31021 13.69 6.31021 14.32 6.70021 14.71C7.09021 15.1 7.72021 15.1 8.11021 14.71L12.0002 10.83L15.8802 14.71C16.2702 15.1 16.9002 15.1 17.2902 14.71C17.6802 14.32 17.6802 13.69 17.2902 13.3L12.7002 8.70998C12.3202 8.31998 11.6802 8.31998 11.2902 8.70998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-expand-less`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconExpandLess

    ```js
    <b-new-b-icon-expand-less />
    ```
</docs>


